import React from "react";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";

const HomePage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.home"));
  return <></>;
};

export default HomePage;
